import React from 'react'

import classNames from './LoadingSpinner.css'

export default function LoadingSpinner ({ style, className = '', show = true, white }) {
  let spinnerClass = show ? classNames.spinnerShowing : classNames.spinner
  if (white) {
    spinnerClass += ' ' + classNames.white
  }
  if (className) {
    spinnerClass += ' ' + className
  }
  return (
    <div className={spinnerClass} style={style}>
      <div className={classNames.topLeft} />
      <div className={classNames.topRight} />
      <div className={classNames.bottomLeft} />
      <div className={classNames.bottomRight} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js